var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-cascader',{staticClass:"customize-form-cascader",attrs:{"value":_vm.innerValue,"options":_vm.options,"placeholder":_vm.placeholder,"append-to-body":false},on:{"input":_vm.onInput}})
}
var staticRenderFns = []

export { render, staticRenderFns }